// Course.icon → heroicon. The catalog stays JSX-free (it is plain data), so
// the mapping lives with the UI.
import {
  BuildingOffice2Icon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  MagnifyingGlassIcon,
  MicrophoneIcon,
  PencilSquareIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  SparklesIcon,
  VideoCameraIcon,
} from "@heroicons/react/24/outline";
import { Course } from "../catalog/types";

const ICONS: Record<Course["icon"], React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  rocket: RocketLaunchIcon,
  microphone: MicrophoneIcon,
  pencil: PencilSquareIcon,
  sparkles: SparklesIcon,
  "document-duplicate": DocumentDuplicateIcon,
  folder: FolderIcon,
  "magnifying-glass": MagnifyingGlassIcon,
  "video-camera": VideoCameraIcon,
  "shield-check": ShieldCheckIcon,
  cog: Cog6ToothIcon,
  "building-office": BuildingOffice2Icon,
};

export const CourseIcon: React.FC<{ icon: Course["icon"]; className?: string }> = ({ icon, className = "h-6 w-6 text-primary" }) => {
  const Icon = ICONS[icon] ?? RocketLaunchIcon;
  return <Icon className={className} />;
};
